export function FilterInput(props: { type?: string, placeholder?: string, label?: string, value?: string, width?: string, onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void }) {
  const { type = 'text', placeholder, label, value, width, onChange } = props
  const widthStyle = width ? { width: `${width}px` } : undefined

  return (
    <label className="w-full" style={widthStyle}>
      {label && <span className="text-sm text-gray-600 mb-[4px] block">{label}</span>}
      <input
        type={type}
        placeholder={placeholder || ''}
        className="w-full h-[33px] px-3 text-[12px] bg-white rounded-[8px] border-[1px] border-[#d9d9d9] shadow-[inset_0px_2px_2px_0px_rgba(0,0,0,0.1),0px_2px_2px_0px_rgba(255,255,255,0.15)]"
        style={widthStyle}
        value={value}
        onChange={onChange}
      />
    </label>
  )
}
